
(function(){
  function openDialog(id){
    var dialog=document.getElementById(id);
    if(!dialog) return;
    if(typeof dialog.showModal==='function') dialog.showModal(); else dialog.setAttribute('open','');
    document.body.classList.add('fynchie-dialog-open');
  }
  function closeDialog(dialog){
    if(!dialog) return;
    if(typeof dialog.close==='function') dialog.close(); else dialog.removeAttribute('open');
    document.body.classList.remove('fynchie-dialog-open');
  }
  document.addEventListener('click',function(e){
    var opener=e.target.closest('[data-fynchie-contact-open]');
    if(opener){e.preventDefault();openDialog(opener.getAttribute('data-fynchie-contact-open'));return;}
    var closer=e.target.closest('[data-fynchie-contact-close]');
    if(closer){e.preventDefault();closeDialog(closer.closest('dialog'));return;}
    if(e.target && e.target.matches('dialog.fynchie-contact-dialog')) closeDialog(e.target);
  });
  document.addEventListener('close',function(e){if(e.target && e.target.matches && e.target.matches('dialog.fynchie-contact-dialog')) document.body.classList.remove('fynchie-dialog-open');},true);
  document.addEventListener('DOMContentLoaded',function(){
    var success=document.querySelector('[data-fynchie-contact-success]');
    if(success){var dialog=success.closest('dialog.fynchie-contact-dialog');if(dialog) openDialog(dialog.id);}
  });
})();
